import Hostapi from '@/core/utils/Hostapi'

export default {
    methods: {
        createUrl(uri) {
            if (uri) {
                const urlApi = Hostapi.getUrlApi()
                return `${urlApi}/filemanager/download?uri=${uri}`
            }
            return ''
        },
        createUrlOdontograma(uri) {
            if (uri) {
                const urlApi = Hostapi.getUrlApi()
                return `${urlApi}/filemanager/download/odontograma?uri=${uri}`
            }
            return ''
        }
    }
}
